import React, { useCallback } from 'react';
import { UserFlagContent } from '../common/user-flag-content';
import { Styled } from './styles';
export const FlagPopOver = ({ onCloseClick, userFlagProps, loading, error, success, onOutsideClick, triggerRef, show, isInFlow, }) => {
    const overflowCheckRef = useCallback((node) => {
        if (node !== null) {
            const popOverWidth = 380;
            const popOverEl = node.parentNode;
            const posX = popOverEl.getBoundingClientRect().left;
            const flagWidth = popOverEl.previousSibling.offsetWidth;
            if (posX + popOverWidth > window.innerWidth) {
                popOverEl.style.marginLeft = -(popOverWidth - flagWidth) + 'px';
            }
        }
    }, []);
    return (React.createElement(Styled.PopOver, { onOutsideClick: onOutsideClick, triggerRef: triggerRef, show: show, isInFlow: isInFlow, "$premiumTheme": userFlagProps.premiumTheme },
        React.createElement(Styled.PopOverContentContainer, { ref: overflowCheckRef, onClick: (e) => {
                e.stopPropagation();
            } },
            React.createElement(React.Fragment, null,
                React.createElement(Styled.CloseButton, { onClick: onCloseClick }),
                React.createElement(Styled.PopOverContent, { "data-testid": "user-flag-content" },
                    React.createElement(UserFlagContent, { userFlagProps: userFlagProps, loading: loading, error: error, success: success }))))));
};
//# sourceMappingURL=flag-pop-over.js.map